import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image',
  standalone: true,
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {
  @Input() src: string;
  @Input() alt: string = '';
  @Input() class: string = '';
  @Input() fallback: string; // fallback is now optional, handled by type/variant if not provided
  @Input() type: 'supplier' | 'user' | 'agent' | 'passenger' = 'user';
  @Input() variant: 'avatar' | 'cover' = 'avatar';

  imgSrc: string;

  private defaultImages = {
    supplier: {
      avatar: 'assets/images/default-supplier.png',
      cover: 'assets/images/default-supplier-cover.jpg'
    },
    user: {
      avatar: 'assets/images/default-avatar.png',
      cover: 'assets/images/default-cover.png'
    },
    agent: {
      avatar: 'assets/images/default-agent.png',
      cover: 'assets/images/default-agent-cover.png'
    },
    passenger: {
      avatar: 'assets/images/default-passenger.png',
      cover: 'assets/images/default-passenger-cover.png'
    }
  };

  ngOnInit() {
    this.imgSrc = this.src || this.getDefaultImage();
  }

  onError() {
    this.imgSrc = this.getDefaultImage();
  }

  private getDefaultImage(): string {
    // Priority: explicit fallback input > type/variant map > user avatar fallback
    if (this.fallback) {
      return this.fallback;
    }
    return this.defaultImages[this.type]?.[this.variant] || 'assets/images/default-avatar.png';
  }
}
